import React, { useState } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
// import useSWR from 'swr'
// import { getData } from '../components/sfc/component-helpers/requesthelpers'
import Layout from '../components/layout'
import { useCanNativeLazyLoad } from '../components/sfc/component-helpers/customhooks'
import Topper from '../components/BillTopper'
import RelatedSection from '../components/sfc/relatedsection'
import CreditsSection from '../components/sfc/creditssection'
import Tabs from '../components/bills/Tabs'
import Progress from '../components/bills/Progress'
import Votes from '../components/bills/Votes'
import GiveInput from '../components/bills/GiveInput'
import * as pageStyles from '../styles/project-modules/billpage.module.less'
import Carousel from '../components/bills/Carousel'
import Subhed from '../components/elements/Subhed'
import { convertDatesToAP } from '../components/sfc/component-helpers/datehelpers'
import VoteSection from '../components/bills/VoteSection'
import useStickyState from '../components/sfc/component-helpers/useStickyState'
import Ad from '../components/sfc/ad'
import Newsletter from '../components/sfc/newsletter'

const BillPage = ({ data, pageContext, location }) => {
  // easy hooks based request library
  // const { data: responseData, error } = useSWR('https://api.kanye.rest', getData, {
  //   onSuccess: (data) => console.log(data),
  //   onError: (err) => console.log(err),
  // })

  // custom hook checks for nativelazyload
  const lazy = useCanNativeLazyLoad()

  const {
    site: { siteMetadata },
    storySettingsSheetJson: { NewsletterID },
    allRelatedLinksSheetJson: { nodes: relatedLinks },
    allAuthorsSheetJson: { nodes: Authors },
    allBillDataJson: { nodes: notThisBill },
    allCreditsSheetJson: {nodes: Credits}
  } = data

  siteMetadata.PROJECT.AUTHORS = Authors

  const {
    bill_number,
    isBillPage,
    updated,
    dead_bill,
    merged_bill,
    bill_id,
    group_name,
    state_url: bill_link,
    year: YEAR,
  } = pageContext

  // pull out bills that overlap groups w/ this one
  const similar_bills = notThisBill.filter(function(b) { 
    if(b.group_name && group_name) {
      return b.group_name.includes(group_name) || group_name.includes(b.group_name)
    } else {
      return null
    }
  })

  const Title = pageContext.title
  const Deck =
    pageContext.description ||
    'TO DO: Bill Description goes here  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas erat et magna aliquam, at viverra velit porta. Donec convallis ac mi id luctus. Vivamus luctus lorem vel ligula tincidunt, nec mattis ligula consectetur. Cras tempor vitae nisl quis lobortis. Maecenas euismod elit diam, sit amet gravida dui interdum in. Aliquam sed libero eget diam eleifend dapibus. Nam dignissim vehicula metus, ut suscipit mauris. Vivamus in mi turpis. Suspendisse potenti. '

  //set up sections here
  const SECTIONS = [
    {
      label: 'Status',
      key: 'status',
      component: (props) => <Progress {...props} />,
    },
    {
      label: 'Latest votes',
      key: 'votes',
      component: (props) => <VoteSection {...props} />,
    },
    {
      label: 'Take action',
      key: 'input',
      component: (props) => <GiveInput {...props} />,
    },
  ]

  //set up sticky state in case we set our lawmakers on the index page or earlier
  let [yourLegislators, setYourLegislators] = useStickyState(
    null,
    'your_legislators'
  )

  //default to the hash so that if someone sends
  // a page with a hash to friend, they'll see the same thing
  const [activeView, setActiveView] = useState(
    location.hash.replace('#', '') || SECTIONS[0].key
  )
  return (
    <Layout meta={siteMetadata}>
      <Topper
        meta={siteMetadata}
        kicker={bill_number}
        Title={Title}
        Deck={Deck}
        reporter_comment={pageContext.reporter_comment}
        reporter_credit={pageContext.reporter_credit}
        Authors={Authors}
        updated={updated}
        bill_link={bill_link}
        isBillPage={isBillPage}
        publicationName={siteMetadata.PROJECT.PUB_NAME}
        url_add={`${pageContext.year}/${pageContext.slug}`}
        yourLegislators={yourLegislators}
        setYourLegislators={setYourLegislators}
        dead_bill={dead_bill}
        merged_bill={merged_bill}
      />
      <main>
        <div className={pageStyles.content}>
          <div className={pageStyles.tabContainer}>
            <Tabs
              sections={SECTIONS}
              activeView={activeView}
              setActiveView={setActiveView}
              location={location}
            />
          </div>

          <div className={pageStyles.sectionsContainer}>
            <div className={pageStyles.sections}>
              {SECTIONS.map((section) => (
                <section
                  role="tabpanel"
                  id={`section-${section.key}`}
                  aria-labelled-by={`#tab-${section.key}`}
                  hidden={activeView === section.key ? false : true}
                >
                  {section.component({
                    bill: pageContext,
                    MARKET_KEY: siteMetadata.PROJECT.MARKET_KEY,
                    yourLegislators: yourLegislators,
                    setYourLegislators: setYourLegislators
                  })}
                </section>
              ))}
            </div>
          </div>
        </div>
        <Ad adLetter='A'/>
        <section className={pageStyles.carouselContainer}>
          <Subhed title={`More bills we’re tracking`} />
          <Carousel
            YEAR={YEAR}
            publicationName={siteMetadata.PROJECT.PUB_NAME}
            cards={similar_bills.length > 3 ? similar_bills : notThisBill}
            MARKET_KEY={siteMetadata.PROJECT.MARKET_KEY}
          />
        </section>
      </main>

      { NewsletterID && <Newsletter />}
      <RelatedSection links={relatedLinks} />
      {/* <CreditsSection creditData={Credits}/> */}
    </Layout>
  )
}

export const query = graphql`
  query pageQuery($bill_number: String) {
    storySettingsSheetJson {
      Title
      Deck
      NewsletterID
    }
    allAuthorsSheetJson {
      nodes {
        AUTHOR_NAME
        AUTHOR_PAGE
      }
    }
    allBillDataJson(filter: { bill_number: { ne: $bill_number } }) {
      nodes {
        title
        description
        bill_number
        status_id
        body_id
        current_body_id
        pending_committee_id
        sponsors
        dead_bill
        merged_bill
        group_name
        simple_body_id
        simple_current_body_id
        non_originating_id
      }
    }
    site {
      siteMetadata {
        EMBEDDED
        MAIN_DOMAIN
        PAYWALL_SETTING
        PROJECT {
          PUB_NAME
          DATE
          DESCRIPTION
          HEARST_CATEGORY
          KEY_SUBJECTS
          IMAGE
          ISO_MODDATE
          ISO_PUBDATE
          OPT_SLASH
          SLUG
          SOCIAL_TITLE
          SUBFOLDER
          TITLE
          TWITTER_TEXT
          ANALYTICS_CREDIT
          MARKET_KEY
          CANONICAL_URL
        }
      }
    }
    allCreditsSheetJson(skip: 1) {
      nodes {
        id
        Email
        Instagram
        Name
        Organization
        Role
        Twitter
      }
    
  }
    allRelatedLinksSheetJson {
      nodes {
        wcmid
        title
        url
      }
    }
  }
`
BillPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default BillPage
